import type { LADClaimFileForEmail } from '../../types';
import type { LADClaimFilesForEmailResponse } from './api';

export const normalizeLADClaimFilesForEmailResponse = (
  response: LADClaimFilesForEmailResponse | null | undefined,
): LADClaimFileForEmail[] => {
  const files = response ?? [];
  return files.map((file) => ({
    ...file,
    isAttached: Boolean(file.isAttached),
  }));
};
